/* ============================================================
   RIDESPHERE — Landing v4 — Script
   Asset path: assets/landing-v4.js
   ============================================================ */
(function () {
  'use strict';

  // Inizializza solo se la landing è presente in pagina
  var landing = document.querySelector('.rs-landing');
  if (!landing) return;

  // === NAV scroll background ===
  var nav = document.getElementById('rs-nav');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 30) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // === Reveal on scroll ===
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rs-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    // Fallback: rimuovi animazione
    document.querySelectorAll('.rs-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }

  // === Reviews carousel — dot nav update ===
  var track = document.getElementById('rs-reviewsTrack');
  if (track) {
    var dots = document.querySelectorAll('.rs-reviews-dot');
    track.addEventListener('scroll', function () {
      var firstCard = track.querySelector('.rs-review-card');
      if (!firstCard) return;
      var cardWidth = firstCard.offsetWidth + 16;
      var idx = Math.round(track.scrollLeft / cardWidth);
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === idx);
      });
    }, { passive: true });
  }

  // === Reviews "Leggi tutto" — espande in-place ===
  document.querySelectorAll('.rs-review-card .rs-read-more').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var card = btn.closest('.rs-review-card');
      card.classList.toggle('expanded');
      btn.textContent = card.classList.contains('expanded')
        ? 'Riduci ↑'
        : 'Leggi tutto →';
    });
  });

  // === Mobile burger (semplice toggle drawer) ===
  var burger = document.querySelector('.rs-burger');
  var navList = document.querySelector('.rs-nav-list');
  if (burger && navList) {
    burger.addEventListener('click', function () {
      var isOpen = navList.classList.toggle('rs-mobile-open');
      // Stile inline veloce per drawer mobile (override .rs-nav-list display:none)
      if (isOpen) {
        navList.style.display = 'flex';
        navList.style.position = 'absolute';
        navList.style.top = '100%';
        navList.style.left = '0';
        navList.style.right = '0';
        navList.style.flexDirection = 'column';
        navList.style.background = 'rgba(10,10,10,0.97)';
        navList.style.padding = '20px';
        navList.style.borderBottom = '1px solid #222226';
        navList.style.alignItems = 'flex-start';
        navList.style.margin = '0';
      } else {
        navList.style.cssText = '';
      }
    });
  }
})();
